import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import clsx from 'clsx'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'

interface CheckboxProps {
    mainColor: boolean
    onClick: (state: boolean, id: string) => void
    size?: 'normal' | 'small'
    text?: string
    checked?: boolean
    labelInfo?: string | null
    disabled?: boolean
    id: string
    readonly?: boolean
    errorMessage?: string
    required?: boolean
    children?: any
    className?: string
    rounded?: boolean
    checkboxMessage?: string
    ariaLabel?: string
}

const CheckBox = (props: CheckboxProps) => {
    const {
        mainColor,
        onClick,
        size = 'normal',
        text,
        checked = false,
        labelInfo,
        disabled,
        id,
        readonly,
        errorMessage,
        required,
        children,
        className,
        rounded,
        checkboxMessage,
        ariaLabel,
    } = props

    const handleToggle = (e: React.SyntheticEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (readonly || disabled) {
            return
        }
        onClick(!checked, id)
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            handleToggle(e)
        }
    }

    const classNames = clsx(
        'checkbox-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        `checkbox-${size}`,
        checked && 'checked',
        disabled && 'disabled',
        readonly && 'readonly',
        rounded && 'rounded',
        className
    )

    return (
        <div
            className={classNames}
            role="checkbox"
            aria-checked={checked}
            aria-disabled={!!disabled || !!readonly}
            aria-label={ariaLabel || text}
            data-testid={'checkbox-component-' + id}
            tabIndex={readonly || disabled ? -1 : 0}
            onKeyDown={handleKeyDown}
        >
            <div
                className="checkbox-wrapper"
                data-tooltip-id={'checkbox-wrapper-' + id}
                onClick={handleToggle}
                data-testid={'checkbox-wrapper-' + id}
            >
                {checked ? <img src={ICONS.done} className="checkbox-icon" alt="checkbox" /> : null}
            </div>
            <span className="checkbox-description">
                <span onClick={handleToggle}>{text}</span>
                <span>{children}</span>
            </span>
            {labelInfo && <CustomToolTip type="i" info={labelInfo} />}
            {errorMessage ? (
                <span className="error-text">{errorMessage}</span>
            ) : (
                required && <span className="required">Required</span>
            )}
            {checkboxMessage && (
                <MlcTooltip
                    id={'checkbox-wrapper-' + id}
                    style={{ maxWidth: '25rem' }}
                    variant="info"
                    place="right"
                    className="custom-tool-tip-content"
                >
                    <span>{checkboxMessage}</span>
                </MlcTooltip>
            )}
        </div>
    )
}

export default observer(CheckBox)
